import React from 'react';

/**
 * Replaces standard <img> tags with an optimized <picture> wrapper
 * for Firebase Storage and Google Auth images.
 */
export default function OptimizedImage({ src, alt, className, width, height, loading = "lazy" }) {
    if (!src) return null;

    // 1. Google User Content (Auth Avatars)
    if (src.includes('lh3.googleusercontent.com')) {
        const optimizedSrc = src.includes('=s') ? src : `${src}=s127-c`;
        return (
            <img 
                src={optimizedSrc} 
                alt={alt || "Image"} 
                className={className} 
                loading={loading}
                width={width}
                height={height}
            />
        );
    }


    // 3. Fallback for any other URLs
    return (
        <img 
            src={src} 
            alt={alt || "Image"} 
            className={className} 
            loading={loading}
            width={width}
            height={height}
        />
    );
}
